import { css } from '@emotion/css';
import { Center, Text, UnstyledButton } from '@mantine/core';
import { IconPlus } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';

import { useAutomationWizardController } from '../controller';

export const AddButton = () => {
  const { t } = useTranslation();
  const {
    actions: { addAction },
    conditions: { addCondition },
    navigation: {
      step: { current },
    },
  } = useAutomationWizardController();

  const [text, onClick] = (() => {
    if (current === 2) return [t(i18nKeys.AUTOMATION.CONDITIONS.ADD_CONDITION), addCondition];
    if (current === 3) return [t(i18nKeys.AUTOMATION.ACTIONS_CONFIG.ADD_ACTION), addAction];
    throw new Error(`Invalid step for AddConditionButton: ${current}`);
  })();

  return (
    <UnstyledButton className={styles.addButton} onClick={onClick}>
      <Center>
        <IconPlus stroke={2} />
        <Text ml="sm" size="" fw="bold">
          {text}
        </Text>
      </Center>
    </UnstyledButton>
  );
};

const styles = {
  addButton: css`
    width: 100%;
    border: 1px dashed var(--mantine-color-default-border);
    border-radius: 8px;
    padding: 8px;
    cursor: pointer;
    transition: 0.2s ease;
    transition-property: background-color, color, border-color;
    color: var(--mantine-color-gray-4);

    :hover {
      background-color: var(--mantine-color-gray-1);
      color: var(--mantine-color-purple-6);
      border-color: var(--mantine-color-purple-6);
    }

    :active {
      transform: translateY(2px);
    }
  `,
};
